module.exports = __webpack_public_path__ + "media/images/side_banner_bg-edefc960c223e8bc12d9d964c2112a1d.svg";